import type { TenantSettings } from './settings';

export const ATTENDANCE_MARKS = ['present', 'absent', 'late'] as const;
export type AttendanceMark = (typeof ATTENDANCE_MARKS)[number];

export const ABSENCE_LEVELS = ['elim', 'alert', 'watch'] as const;
export type AbsenceLevel = (typeof ABSENCE_LEVELS)[number];

/** Roll-call tap cycle (design MobAppel): Présent → Absent → Retard → Présent. */
export function nextMark(m: AttendanceMark): AttendanceMark {
  return m === 'present' ? 'absent' : m === 'absent' ? 'late' : 'present';
}

/** Unjustified absence rate of an ECUE, in percent of its volume (0 when the volume is unknown). */
export function absenceRate(unjustifiedHours: number, volumeHours: number): number {
  return volumeHours > 0 ? (unjustifiedHours / volumeHours) * 100 : 0;
}

/** Monitoring level for a rate: éliminé ≥ elimination, alerte ≥ alert, surveillé ≥ watch. */
export function absenceLevel(
  pct: number,
  rules: Pick<TenantSettings['attendance'], 'eliminationPct' | 'alertPct' | 'watchPct'>,
): AbsenceLevel | null {
  if (rules.eliminationPct !== null && pct >= rules.eliminationPct) return 'elim';
  if (pct >= rules.alertPct) return 'alert';
  if (pct >= rules.watchPct) return 'watch';
  return null;
}

/** Hours between two instants, rounded to the quarter hour. */
export function sessionHours(startsAt: Date | string, endsAt: Date | string): number {
  const ms = new Date(endsAt).getTime() - new Date(startsAt).getTime();
  return Math.max(0, Math.round((ms / 3_600_000) * 4) / 4);
}

/** "9 h", "7 h 30" (design ScrAbsences). */
export function formatHours(hours: number): string {
  const h = Math.floor(hours);
  const m = Math.round((hours - h) * 60);
  return m ? `${h} h ${String(m).padStart(2, '0')}` : `${h} h`;
}
